import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="w-full py-10 md:py-12 bg-secondary-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <Link to="/" className="font-heading text-lg font-semibold text-foreground-900 cursor-pointer">
              Kakobuy<span className="text-primary-500">Polska</span>
            </Link>
            <p className="text-xs text-foreground-500 mt-2 max-w-[300px]">
              Niezależny przewodnik Kakobuy Spreadsheet dla polskich użytkowników. Pomagamy znaleźć najlepsze produkty i robić bezpieczne zakupy.
            </p>
          </div>

          <div>
            <h4 className="text-xs font-semibold text-foreground-700 uppercase tracking-wider mb-3">
              Nawigacja
            </h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer">
                Strona główna
              </Link>
              <Link to="/poradnik" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer">
                Poradnik zakupowy
              </Link>
              <Link to="/bezpieczenstwo" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer">
                Bezpieczeństwo
              </Link>
              <Link to="/porownanie" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer">
                Porównanie
              </Link>
            </div>
          </div>

          <div>
            <h4 className="text-xs font-semibold text-foreground-700 uppercase tracking-wider mb-3">
              Kakobuy
            </h4>
            <div className="flex flex-col gap-2">
              <a href="#categories" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer">
                Kategorie produktów
              </a>
              <a href="#articles" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer">
                Artykuły
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer"
              >
                Kakobuy Spreadsheet
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer"
              >
                Kup teraz
              </a>
            </div>
          </div>
        </div>

        <div className="mt-8 pt-6 border-t border-secondary-200/70 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500 text-center sm:text-left">
            &copy; 2026 Kakobuy Polska Spreadsheet. Wszelkie prawa zastrzeżone.
          </p>
          <p className="text-xs text-foreground-400 text-center sm:text-right">
            Kakobuy Polska Spreadsheet jest niezależnym przewodnikiem. Nie jesteśmy powiązani z Kakobuy.
          </p>
        </div>
      </div>
    </footer>
  );
}